<template>
    <a :href="result.PageUrl" class="d-flex flex-column col-lg-4 col-sm-6">
        <div class="card card-basic" :class="colorClass">
            <div
                v-if="showImage"
                class="card__image"
                :style="{
                    backgroundImage: 'url(' + result.Background + ')'
                }"
            ></div>
            <div
                class="card__text"
                :class="{ 'card__text--pb': result.Date != '' }"
            >
                <div class="card__text__top">
                    <span v-if="result.Level > 3" class="card__subject">{{
                        result.ParentName
                    }}</span>
                    <h2>{{ result.Title }}</h2>
                </div>
            </div>
            <div class="card__bottom">
                <div class="card__bottom__date">
                    <time>{{ result.Date }}</time>
                </div>
                <div class="card__bottom__button">
                    <span class="card__bottom__button__content"
                        >Lees meer<span
                            class="icon-angle-right card__bottom__button__content__icon"
                        ></span
                    ></span>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        result: {
            type: Object,
            required: true
        },
        showImage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isInResults: function() {
            return this.$parent.$parent.filteredResults.includes(this.result);
        },
        colorClass: function() {
            if (this.result !== null && this.result.ParentColor !== null) {
                return 'card--' + this.result.ParentColor.Label;
            }

            return '';
        }
    }
};
</script>
